import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import https from "https";
import axios from "axios";
import log from "../utils/log";
import metaData from "../data/metaData";
import c from "../utils/common";

//
import useAuthStore from "../states/useAuth";

const useDB = () => {
  const { auth } = useAuthStore();

  const get = async (url, query) => {
    // log.debug(query);
    const response = await axios.post(metaData.serverURL + url, query, {
      headers: { Authorization: auth.jwt },
      httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
    });
    return response.data; // Return the updated data
  };

  return { get };
};

export default useDB;
